import axios from './axios'
import { IAreaFormDefault } from '../@types/refact/IAreaAPI'

const getAreabyId = <T = IArea>(areaId: number, formatDatacallBack?: (data: IArea) => any): Promise<T> => {
    return axios.get<IArea>(`/areas/${areaId}`).then(({ data }) => {
        if (formatDatacallBack) return formatDatacallBack(data)
        return data
    })
}

const getAreabyFarmId = <T = IArea[]>(farmId: number, formatDatacallBack?: (data: IArea[]) => any): Promise<T> => {
    return axios.get<IArea[]>(`/areas?farm_id=${farmId}`).then(({ data }) => {
        if (formatDatacallBack) return formatDatacallBack(data)
        return data
    })
}

const createNewArea = (body: ICreateArea[]): Promise<any> => {
    return axios.post(`/areas`, body).then(({ data }) => {
        return data
    })
}

const editArea = (data: IEditArea[]): Promise<IEditArea> => {
    return axios.patch('/areas', data)
}

const deleteArea = (areaId: number): Promise<any> => {
    return axios.delete(`/areas/${areaId}`)
}

const getAreasByUser = (): Promise<IArea[]> => {
    return axios.get<IArea[]>(`/areas/user`).then(({ data }) => {
        return data
    })
}

const getAreaByIdForForm = (areaId: number): Promise<IAreaFormDefault> => {
    return axios.get(`/areas/${areaId}`).then(({ data }) => {
        return {
            id: data.id,
            name: data.name,
            initials: data.initials,
            acreage: data.acreage?.toFixed(2),
            farm_id: data.farm?.id || null,
            farm_initials: data.farm_inititals,
            manager_user_id: data.manager_user.id,
            manager_user_name: data.manager_user.name,
            map_coords: data.map_coords,
            indoor_grazing_time: data.indoor_grazing_time,
            outdoor_grazing_time: data.outdoor_grazing_time
        }
    })
}

export const areaService = {
    getAreabyId,
    editArea,
    deleteArea,
    createNewArea,
    getAreabyFarmId,
    getAreasByUser,
    getAreaByIdForForm
}